import { Controller } from "@hotwired/stimulus"

const CLIPBOARD_LIVE_ID = "cotherapist-clipboard-live"

export default class extends Controller {
  static values = { text: String }

  copy(event) {
    event.preventDefault()
    const text = this.textValue
    if (!text) return

    const btn = this.element
    const originalText = btn.textContent
    navigator.clipboard.writeText(text).then(() => {
      const copied = btn.dataset.copiedLabel || "Copied!"
      btn.textContent = copied
      this.announce(copied)
      setTimeout(() => { btn.textContent = originalText }, 2000)
    })
  }

  announce(message) {
    let region = document.getElementById(CLIPBOARD_LIVE_ID)
    if (!region) {
      region = document.createElement("div")
      region.id = CLIPBOARD_LIVE_ID
      region.className = "app-sr-only"
      region.setAttribute("role", "status")
      region.setAttribute("aria-live", "polite")
      region.setAttribute("aria-relevant", "additions text")
      document.body.appendChild(region)
    }
    region.textContent = ""
    window.requestAnimationFrame(() => {
      region.textContent = message
    })
  }
}
